import { render, staticRenderFns } from "./LoadingSign.vue?vue&type=template&id=508110fe&"
import script from "./LoadingSign.vue?vue&type=script&lang=js&"
export * from "./LoadingSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports